import { memo, MouseEventHandler } from "react";

import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

import { useOrganizationStore } from "stores/OrganizationStore";

import awsConfig from "external/source/aws/config";

import ServiceConnectionStep from "components/ServiceConnectionStep";

// -----------------------------------------------------------------------------

const InstallCloudFormationTemplatePhase = memo(
  function InstallCloudFormationTemplatePhase({
    disabled,
    onNext,
  }: InstallCloudFormationTemplatePhaseProps): JSX.Element {
    const [organizationStore] = useOrganizationStore();

    //
    return (
      <ServiceConnectionStep disabled={disabled}>
        <Typography variant="body1">
          The cloud formation template creates an IAM role with permissions to
          configure log forwarding and fix security issues. For more details on
          what it does and how we use it, you can inspect the{" "}
          <a href="https://s3.amazonaws.com/threatkey-assets/aws/provision.yml">
            CloudFormation template file
          </a>{" "}
          and read more in our{" "}
          <a href="https://docs.threatkey.com/article/10-aws">
            technical documentation
          </a>
          .
        </Typography>
        <Stack sx={{ mt: 2 }} spacing={2} direction="row">
          <Button
            variant="contained"
            component="a"
            href={`https://console.aws.amazon.com/cloudformation/home#/stacks/create/review?templateURL=${
              awsConfig.cloudFormationTemplateURL ?? ""
            }&stackName=threatkey-role-${
              organizationStore.uuid
            }&param_ThreatKeyOrgId=${organizationStore.uuid}`}
            target="_blank"
            rel="noopener noreferrer"
            onClick={onNext as MouseEventHandler<HTMLAnchorElement>}
          >
            Install Template
          </Button>
          <Button
            variant="text"
            onClick={onNext as MouseEventHandler<HTMLButtonElement>}
          >
            Skip (Role already created)
          </Button>
        </Stack>
      </ServiceConnectionStep>
    );
  }
);

export default InstallCloudFormationTemplatePhase;

// -----------------------------------------------------------------------------

interface InstallCloudFormationTemplatePhaseProps {
  disabled: boolean;
  onNext: Function;
}
